import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core'
import {PERMISSION} from "@generated-backend-types";
import {UserSessionService} from '../services/user-session-service/user-session.service';

@Directive({
    selector: '[appIfHasAllPermissions]',
    standalone: true
})
export class IfHasAllPermissionsDirective {
  private readonly element = inject(ElementRef);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly authService = inject(UserSessionService);

  @Input() set appIfHasAllPermissions(permissions: PERMISSION[]) {
    if (permissions && permissions.length > 0 && this.authService.hasAllPermission(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }
}
